/// <reference path="../types.d.ts" />
import { createAction } from '@reduxjs/toolkit';
import { commonActions } from '@codametrix/ui-common';
import { CMxComponents } from '@codametrix/ui-components/src/types';
import { ToastVariants } from '../core/enums';
import { BROADCAST_ACTION_METADATA } from './action-constants';

const { CMxApplication, UserInterface } = commonActions;

const dismissModal = createAction(UserInterface.DISMISS_MODAL_MESSAGE, () => ({
  payload: undefined as void,
  meta: { ...BROADCAST_ACTION_METADATA }
}));

// showModalMessage cannot be broadcast because payloads may include functions,
// which are not structured-cloneable across window channels.
const showModalMessage = createAction<CMxComponents.ModalProps>(
  UserInterface.SHOW_MODAL_MESSAGE
);

const dismissFeedback = createAction<boolean>(CMxApplication.DISMISS_FEEDBACK);

const showFeedback = createAction<CMxCommonApp.Feedback>(
  CMxApplication.FEEDBACK
);

const showFeedbackError = (props: Partial<CMxCommonApp.Feedback>) => {
  const arg = {
    ...props,
    className: `${props.className} toast-error`,
    status: ToastVariants.ERROR,
    id: Date.now()
  } as CMxCommonApp.Feedback;
  return showFeedback(arg);
};

const showFeedbackSuccess = (props: Partial<CMxCommonApp.Feedback>) => {
  const arg = {
    ...props,
    className: `${props.className} toast-success`,
    status: ToastVariants.SUCCESS,
    id: Date.now()
  } as CMxCommonApp.Feedback;
  return showFeedback(arg);
};

const showFeedbackWorking = (props: Partial<CMxCommonApp.Feedback>) => {
  const arg = {
    ...props,
    className: `${props.className} feedback-working toast-success`,
    status: ToastVariants.INFO,
    id: Date.now()
  } as CMxCommonApp.Feedback;
  return showFeedback(arg);
};

const showFeedbackWarning = (props: Partial<CMxCommonApp.Feedback>) => {
  const arg = {
    ...props,
    className: `${props.className} feedback-warning toast-warning`,
    status: ToastVariants.WARNING,
    id: Date.now()
  } as CMxCommonApp.Feedback;
  return showFeedback(arg);
};

export {
  dismissFeedback,
  dismissModal,
  showFeedback,
  showFeedbackError,
  showFeedbackSuccess,
  showFeedbackWarning,
  showFeedbackWorking,
  showModalMessage
};
